export default "__VITE_ASSET__49a130df__"